import React from "react";

const Landing: React.FC = () => {
  return <div>Landing layout</div>;
};

export default Landing;
